<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">Recently Accepted<span class="sub-title"> - Past 30 days</span></h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
    ></item-picker>
  </div>
  <div *ngIf="loaded">
    <div class="items-container" *ngIf="odataResult.length > 0">
      <ng-scrollbar>
        <app-recent-accepts-item
          *ngFor="let item of odataResult"
          [item]="item"
          [workspaces]="workspaces"
          [activeWorkspaceIsOrg]="activeWorkspaceIsOrg"
        ></app-recent-accepts-item>
      </ng-scrollbar>
    </div>

    <div class="no-content" fxLayout="column" fxLayoutAlign="center center" *ngIf="odataResult.length == 0">
      <p class="m-0">No one has accepted any invitations in the past 30 days.</p>
      <p>You have invited {{ invitedPeopleCount }} people in the past 30 days</p>
      <a mat-raised-button color="primary" href="https://support.lineupteams.com/hc/en-us/articles/4446812515863"
        >LEARN ABOUT REMINDERS</a
      >
    </div>
  </div>
  <div *ngIf="!loaded" class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>Loading...</p>
  </div>
</div>
